import { get, writable } from "svelte/store";
import { APP_NAME } from "./db";

let data = localStorage.getItem(APP_NAME + "app_store");

let _store;
if (data) {
  try {
    data = JSON.parse(data);
    _store = writable(data);
  } catch (error) {
    console.error(error);
  }
} else {
  _store = writable({
    settingBGColor: "#ffffff",
    settingWidth: 512,
    settingSpeed: 0,
    settingDelay: 0,
  });
}

const storeSetting = {
  saveStore() {
    localStorage.setItem(
      APP_NAME + "app_store",
      JSON.stringify(storeSetting.getStore())
    );
  },

  init() {},

  getStore() {
    return get(_store);
  },
  trigger() {
    _store.update((s) => {
      const newStore = { ...s };
      return newStore;
    });
  },
  setValueToggle(name) {
    const oldValue = this.getStore()[name];
    _store.update((s) => {
      const newStore = { ...s, [name]: !oldValue };
      return newStore;
    });
  },
  subscribe: _store.subscribe,

  setValue(name, value) {
    _store.update((s) => {
      const newStore = { ...s, [name]: value };
      return newStore;
    });
  },
  setValues(values) {
    _store.update((s) => {
      const newStore = { ...s, ...values };
      return newStore;
    });
  },
};

export default storeSetting;
